import { ComponentDataDestService } from '../component-data-dest.service';
import { catchError, map, tap } from 'rxjs';
import { Room } from '../../../models/location/Room.model';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { notifyDunaLocationsAdminFormSuccess, refreshAllLocationTableStores } from './location-stores-refresh';

export function update_room(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const guid = data.guid;
  if (!guid) {
    console.error('[update_room] Missing guid');
    throw new Error('Manglende rum-id');
  }

  const roomModel = new Room(
    guid,
    data.room_name,
    data.location_guid,
    Number(data.capacity),
    data.description || ''
  );
  const dto = Room.toDTO(roomModel);
  const room = {
    guid: dto.guid,
    room_name: dto.room_name,
    location_guid: dto.location_guid,
    capacity: dto.capacity,
    description: dto.description
  };

  const request$ = componentDataDestService.http
    .put(`${environment.apiUrl}/locations/rooms/${guid}`, { room })
    .pipe(
      catchError((error) => {
        console.error('[update_room]', error);
        throw error;
      }),
      map((response) => response)
    );

  return componentDataSourceService.updateStoreData(request$, 'rooms').pipe(
    tap(() => {
      refreshAllLocationTableStores(componentDataSourceService);
      notifyDunaLocationsAdminFormSuccess();
    })
  );
}
